module.exports = __webpack_public_path__ + "img/hotel.ff40c28f.png";